import clsx from 'clsx';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BaseAvatar from '@components/base/BaseAvatar';

interface IUserProfileProps {
    profile: {
        profileImage: string;
        name: string;
        balance: number;
        hold: number;
        currencyIcon: IconDefinition;
    };
    isBurger?: boolean;
}

const UserProfile: React.FC<IUserProfileProps> = ({
    profile: { profileImage, name, balance, currencyIcon },
    isBurger,
}) => {
    const [firstName] = name?.split(' ') || [];

    return (
        <div className="relative flex items-center h-full text-left">
            <BaseAvatar
                className={clsx(
                    'w-[32px] h-[32px] xs:w-[40px] xs:h-[40px] md:w-[44px] md:h-[44px]',
                    isBurger && 'w-[44px] h-[44px] xs:w-[44px] xs:h-[44px]',
                )}
                src={profileImage}
            />
            <div className={clsx('w-full ml-2', !isBurger && 'hidden md:block')}>
                {firstName ? (
                    <>
                        <h5 className="font-medium text-p1 text-blueGray-800">
                            {isBurger ? firstName : firstName?.slice(0, 10)}
                        </h5>
                        <p className="text-blueGray-600 text-p2">
                            {balance}&nbsp;
                            <FontAwesomeIcon icon={currencyIcon} />
                        </p>
                    </>
                ) : (
                    <>
                        <div className="w-24 h-4 mb-2 bg-gray-300 rounded-2 animate-pulse" />
                        <div className="w-24 h-4 bg-gray-300 rounded-2 animate-pulse" />
                    </>
                )}
            </div>
        </div>
    );
};

export default UserProfile;
